import { useRef } from "react";
import { Button, Space } from "antd";
import { PlusOutlined } from '@ant-design/icons';
import CustomIcon from "../CustomIcon";
import chartImg from '../../assets/images/chart.png';
import navigatorImg from '../../assets/images/navigator.png';
import DateTimeSelector from "./DateTimeSelector";
import datepicker from '../../assets/images/datepicker.png';

const Timecontroler = ({
    setMoveNavigator,
    setDraggableLinePosition,
    setOpen,
    setSteps,
    ref54,
    disabledButtons,
    startDatePrediction,
    endDatePrediction,
    scenarioBase,
    draggableLinePosition,
    chartOptions,
    setNewForecastLineTimestamp,
    linePositions,
    setIsAddNewForecast,
    moveNavigator
}) => {
    const ref10 = useRef(null);
    const ref11 = useRef(null);
    const ref12 = useRef(null);
    const ref50 = useRef(null);
    const ref51 = useRef(null);
    const ref52 = useRef(null);
    const ref53 = useRef(null);

    const timeIntervals = [1, 6, 12, 24, 48];

    const movePlotLine = (hours) => {
        setMoveNavigator(true);
        setDraggableLinePosition((prevPosition) => (prevPosition + hours * 3600 * 1000) - 345600000);
      };
    
      const steps = [
        {
          title: 'Contrôle de la timeline',
          description: "Vous allez pouvoir contrôler votre déplacement sur la période avec précision. des boutons vous permettent de vous déplacer d'heure en heure ou faire des sauts de 6, 12, 24 ou 48 heures. Vous pouvez aussi déplacer manuellement le curseur....",
          target: () => ref50.current,
        },
        {
          title: 'Contrôle de la timeline',
          description: 'Les boutons permettent de se déplacer finement de manière continue sur le pas de temps choisi. Pratique pour suivre les prédictions !',
          target: () => ref51.current,
        },
        {
            title: 'Contrôle de la timeline',
            description: "Ils agissent directement sur la timeline au dessus pour déplacer le curseur de la prédiction",
            cover: (
                <img src={chartImg} alt="graph de prédiction" />
            ),
            target: () => ref52.current,
        },
        {
            title: 'Contrôle de la timeline',
            description: "La timeline représente l'ensemble de la période du scénario. La prtie grisée représente la vue du graph. vous pouvez faire glisser la période sur la timeline, l'agrandir ou la rétrécir...",
            cover: (
                <img src={navigatorImg} alt="timeline" />
            ),
            target: () => ref53.current,
        },
        {
          title: 'Contrôle de la timeline',
          description: 'Par défaut tous les départements sont affichés. Vous pouvez afficher une liste de départements choisis depuis le sélecteur',
          target: () => ref54.current,
        },
        {
            title: 'Contrôle de la timeline',
            description: 'Choisir une date précise est également possible !',
            target: () => ref10.current,
          },
          {
            title: 'Contrôle de la timeline',
            description: 'Vous pouvez choisir une date et une heure pour afficher la prédiction de référence. le curseur de la timeline se positionne automatiquement à la date choisie',
            target: () => ref11.current,
          },
          {
            title: 'Contrôle de la timeline',
            description: "Une fois que vous avez choisi votre date et heure cliquez sur 'OK' dans le calendrier pour l'afficher",
            cover: (
                <img src={datepicker} alt="valider la date" />
            ),
            target: () => ref12.current,
          },
      ]

    return (
        <article className="time-controler" ref={ref50}>
            <h2 className="info-bulle" level={4} style={{ textAlign: 'center', marginBottom: '16px' }}>
                Contrôle de la Timeline
                <CustomIcon setOpen={setOpen} setSteps={setSteps} steps={steps} />
            </h2>
            <Space ref={ref51} style={{ marginBottom: '16px', display: 'flex', justifyContent: 'center' }}>
            {timeIntervals.map((hours) => (
                <Space key={hours} align="center">
                <Button
                    ref={ref52}
                    onClick={() => movePlotLine(hours)}
                    type="primary"
                    icon={<PlusOutlined />}
                    style={{ marginLeft: '4px' }}
                    disabled={disabledButtons[hours]}
                >
                    {`${hours}h`}
                </Button>
                </Space>
            ))}
            <DateTimeSelector
                startDatePrediction={startDatePrediction}
                endDatePrediction={endDatePrediction}
                draggableLinePosition={draggableLinePosition}
                setMoveNavigator={setMoveNavigator}
                scenarioBase={scenarioBase}
                setDraggableLinePosition={setDraggableLinePosition}
                chartOptions={chartOptions} 
                setNewForecastLineTimestamp={setNewForecastLineTimestamp} 
                linePositions={linePositions} 
                setIsAddNewForecast={setIsAddNewForecast}
                moveNavigator={moveNavigator}
                setOpen={setOpen}
                setSteps={setSteps}
                ref10={ref10}
                ref11={ref11}
                ref12={ref12}
            />
            </Space>
        </article>
    );
}

export default Timecontroler;